<template>
    <div>
        <footer class="container-fluid p-3">
            <div id="ex1" style="max-width:60em;"></div>
            <a id='modal-licenciamento' href="#ex1" rel="modal:open" hidden="true"></a>

            <div class="row footer col-12">
                <div class="col-12 col-sm-9 ml-4">
                    <small>Copyright & Copyleft &copy; All material in this platform is the property of the contributing authors and partners.</small>
                </div>
                <div class="row col-12 col-sm-3 text-center powerlliege">
                    <small class="ml-5"><i> powered by</i><br>&copy;2014 - {{ new Date().getFullYear() }}</small>
                    <a id="chamaModal"><img src="@/assets/img/lg_lliege_inline.png" alt="Logo Lliege" height="28"></a>
                </div>    
            </div>
        </footer>
    </div>
</template>

<script>

export default {
    name: 'Rodape',
    mounted: function(){
        $("#chamaModal").on('click', function(e) {
            e.preventDefault();
            $.ajax({
            type: "GET",
            url: "http://api.controle.lliege.com.br/api/licenciamento",
            contentType: 'text/html; charset=UTF-8',
            success: function(html) {
                $(html).appendTo('#ex1').modal();
                $('#modal-licenciamento').click();
            }
            })
        });
    }
}

</script>

<style scoped>
    footer {
        background-color: #aaa;
        color: #fff;
    }

    .footer {
        bottom:0;
        margin-left: 1%;
        
    }
    .footer img {
        cursor: pointer;
        margin-top: 2px;
    }
    .modal {
        overflow: auto;
    }
</style>


